export default "__VITE_ASSET__BR4AGNQ8__"